import { apiClient } from "lib/apiClient";

type Response = {
  id: string;
  filename: string;
  creationDate: string;
  lastModifiedDate: string;
};
export const addPropertyPhotos = async (
  propertyId: string,
  photos: File[],
  order: number
): Promise<Response> => {
  const formData = new FormData();

  photos.forEach((file) => {
    formData.append("photos", file);
  });

  const response = await apiClient.post(
    `/properties/${propertyId}/photo?order=${order}`,
    formData
  );

  return response.data;
};
